// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"eI","speechCardBox":"eI","speech-img-box":"eJ","speechImgBox":"eJ","card-content":"eK","cardContent":"eK","card-src":"eL","cardSrc":"eL"};